// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import GateConstants from 'constants/GateConstants'

const GateActions = Marty.createActionCreators({
  gatesUpdated(gates) {
    return this.dispatch(GateConstants.GATES_UPDATE_DONE, gates)
  }
})

export default GateActions



// WEBPACK FOOTER //
// ./src/scripts/actions/GateActions.js